<!-- LISTA DE DI'S

FALTA TESTE DE EXCLUSAO DA DI
FALTA GERAR PDF DA DANFE DA NF ANTES DA AUTORIZACAO (nfimport-list.handlePreviewPDF)

-->


<script>
import axios from 'axios'
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import nfsaidaForm from './nfsaida-form'
import nfimportForm from './nfimport-form'
import { apiDownloadPDF, apiORDSpost, apiValidaLimitePlano } from '../shared/api-functions'
import { urlORDS } from '../shared/api-functions'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao de DI
            showEntradaForm: false, //exibe a tela de manutencao de nota de entrada
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,
            filterList: [], //lista de filtros aplicados que são exibidos em tela
            moreActionsBarList: [],
            monthFilter: {},
        }
    },
    computed: {
        diList: function () {
            return this.$store.getters.getDiList
        },
    },
    methods: {
        moreActionsGrid (di) {
            //RETORNA O OBJETO PARA O BOTAO "MAIS ACOES"
            var obj = []
            if (di.stdi == '1') {
                obj.push({ action: '1', label: 'Gerar NFe', id: di.coddi})
            }
            if (di.codnf) {
                obj.push({ action: '2', label: 'Visualizar Danfe', id: di.codnf})
            }
            return obj
        },

        optionsGrid (di) {
            //RETORNA OBJETO PARA A BARRA DE BOTOES DO GRID DA DI
            if (di.stdi == '0') {  //DI COM PENDENCIAS
              return {barDefault: true, btnEdit: true, btnDelete: true, btnView: true}
            } else
            if (di.stdi == '1') {  //DI PRONTA PARA EMISSAO DE NF
              return {barDefault: true, btnEdit: true, btnDelete: true, btnView: true}
            } else { //DI COM NF EMITIDA
              return {barDefault: true, btnEdit: false, btnDelete: false, btnView: true}
            }
        },


        handleEdit (coddi) {
            //abre formulario para edicao da DI
            this.crud = SysVars.crudU //operacao de edicao
            this.params = { coddi: coddi } //codigo da DI
            this.showForm = true
        },

        handleDelete (coddi) {
            //abre formulario para exclusao da DI
            this.crud = SysVars.crudD //operacao de exclusao
            this.params = { coddi: coddi } //codigo da DI
            this.showForm = true
        },

        handleEditNFe (codnf) {
            //abre formulario para edicao da NFe apos a geracao
            this.crud = SysVars.crudU //operacao de edicao
            this.params = { codnf: codnf } //codigo da NF
            this.showEntradaForm = true
        },

        handleView (coddi) {
            //abre a tela de edicao
            this.crud = SysVars.crudView //visualizacao
            this.params = {}
            this.params.coddi = coddi //codigo da nf
            this.showForm = true; //exibe o form de manutencao
        },

        async apiPostNFe (coddi) {
            //EFETUA A GERACAO DA NF DE ENTRADA (NOTA ÚNICA)

            var sendData = { di: { coddi: coddi, diit: [] } } //envia o codigo da DI para geracao da nfe

            const data = await apiORDSpost(this.$store, 'invoice/nfimportacao/di/', sendData, 'post')
            if (data.items) {
                if (data.errmessages) {
                    this.$erpToastError('Erro: ' + data.errmessages[0])
                } else {
                    let codnf = data.items[0].codnf
                    this.handleEditNFe(codnf)
                    this.$erpToastSuccess('A NF-e foi gerada com sucesso.')
                }
            }
        },


        handleAction (act, obj) {
            // BOTAO MAIS ACOES DA DI

            if (act == 1) { //GERACAO DA NFE
              this.apiPostNFe(obj.coddi)
            }

            if (act == 2) { //PREVIEW DA DANFE
                //VISUALIZACAO DO PDF ANTES DA AUTORIZACAO DA NFE
                if (obj && obj.codnf)
                  apiDownloadPDF(this, 'print/previewdanfe/' + obj.codnf)
            }

        },

        handleActionBarList (act) {
            if (act == 1) {
                //efetua importacao do xml da DI
                this.handleImportarXML()
            }
        },

        handleIncluir () {
            //Importacao do xml da DI
            this.handleImportarXML()
        },

        closeForm() {
            this.showEntradaForm = false
            this.showForm = false
            this.loadData()
        },

        handleSearch(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"nome":{"$like":"%25' + value + '%25"}},{"numerodi":{"$eq":"' + value + '"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadDiList', { filter: this.filter} )
        },

        textST (value) {
            return getText(value, this.metadata.di.stdi)
        },

        data (value) {
            return formatDate(value)
        },

        async handleImportarXML() {
            const isValid = await apiValidaLimitePlano(this, 'nfimportacao_xmldi')
            if (!isValid)
              this.closeForm()

            //SELECIONA ARQUIVO XML PARA IMPORTACAO DA NF DE ENTRADA
            this.$refs.xmlFile.value = ''
            this.$refs.xmlFile.click()
        },

        handleUploadXML () {
            //ENVIA O ARQUIVO XML SELECIONADO PARA EFETUAR IMPORTACAO
            var files = this.$refs.xmlFile.files
            if (files.length == 0) {
               return
            }

            var self = this

            let file = files[0]
            let formData = new FormData()
            formData.append(file.name, file)
            let modulo = 'invoice/di/'
            axios.post(urlORDS(this.$store, modulo), formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
            ).then(function(response){
                    if (response.data.errmessages) {
                       self.$erpToastError('Erro na importação do XML: ' + response.data.errmessages[0])
                    } else {
                        let coddi = response.data.items[0].coddi
                        self.handleEdit(coddi)
                        self.$erpToastSuccess('O XML foi importado com sucesso.')
                    }
                })
                // .catch(function(response){
                    // self.$erpToastError(response.data.errmessages)
                // })

        },

    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },

    },

    components: {
        BarList, BarGrid, nfimportForm, nfsaidaForm
    },

    created () {
        //botao mais acoes na barra do grid
        this.moreActionsBarList = [
            { action: 1, label: 'Importar XML de DI' }]

        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm && !showEntradaForm">
            <bar-list
                :refresh-button="true"
                :new-button="true"
                :pdf-button="false"
                :xls-button="false"
                :filtro-mes="true"
                :filter-button="true"
                single-entity="Declaração Importacao"
                plural-entity="Declaração Importacao"
                :moreActions="moreActionsBarList"
                :month-filter="monthFilter"
                @action="handleActionBarList"
                @search="handleSearch"
                @new="handleIncluir"
                @refresh="loadData"
                @changeMonth="handleSearch"
                title-search="Pesquise pelo nome do fornecedor ou número do DI">
            </bar-list>

            <div class="default-container mt-3">
                <alert v-if="diList.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="di in diList" v-bind:key="di.coddi">
                    <!-- <div v-bind:class="[{ 'mark-yellow': (di.stnf === '00') }, { 'mark-green': (di.stnf === '10') }]"></div> -->
                    <div class="mark-gray"></div>
                    <div class="box pl-3 pl-md-0">
                        <div class="row">
                            <div class="col-7 col-md-12 row">
                                <div class="col-md-2 col-12" style="float: left">
                                    <label class="lbl-list">Número </label><br>
                                    <span class="data-list">{{ di.numerodi }}</span>
                                </div>
                                <div class="col-md-2 col-12 d-none d-md-block">
                                    <label class="lbl-list">Data:</label><br>
                                    <span class="data-list">{{ data(di.data) }}</span>
                                </div>
                                <div class="col-md-3 col-12 d-md-flex d-none">
                                    <label class="lbl-list">Natureza:</label><br>
                                    <span class="data-list">{{ di.descricao }}</span>
                                </div>
                                <div class="col-md-2 col-3">
                                    <label class="lbl-list">Total FOB:</label><br>
                                    <span class="data-list">{{ di.vfob | format }}</span>
                                </div>
                                <div class="col-md-2 col-5 d-none d-md-block">
                                    <bar-grid
                                        :obj="di"
                                        :options="optionsGrid(di)"
                                        :moreActions="moreActionsGrid(di)"
                                        @view="handleView(di.coddi)"
                                        @edit="handleEdit(di.coddi)"
                                        @delete="handleDelete(di.coddi)"
                                        @action="handleAction">
                                    </bar-grid>
                                </div>
                                <div class="col-md-1 col-16">
                                    <!-- <v-button label="Gerar NFe" title="" icon="fa-arrow-right" @click="closeForm"></v-button> -->
                                </div>
                            </div>
                            <div class="col-5 d-flex flex-column align-items-end justify-content-end d-md-none">
                                <div class="col-md-2 col-6">
                                    <bar-grid
                                        :obj="di"
                                        :options="optionsGrid(di)"
                                        :moreActions="moreActionsGrid(di)"
                                        @view="handleView(di.coddi)"
                                        @edit="handleEdit(di.coddi)"
                                        @delete="handleDelete(di.coddi)"
                                        @action="handleAction">
                                    </bar-grid>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2 col-3">
                                <span class="badge" :class="[{'badge-green': di.stdi=='1'},{'badge-orange': di.stdi=='0'}]" >{{ textST(di.stdi) }}</span>
                            </div>
                            <div class="col-md-5 col-6 d-md-flex d-none">
                                <label class="lbl-list">Fornecedor:</label><br>
                                <span class="data-list">{{ di.nome }}</span>
                            </div>
                            <div v-if="di.nf" class="col-md-2 col-3 d-md-flex d-none">
                                <label class="lbl-list">Série/NF:</label><br>
                                <span class="data-list">{{ di.nf }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-6">
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <!-- INPUT PARA IMPORTACAO DO XML -->
        <div v-show="false" class="row">
            <input type="file" ref="xmlFile" accept=".xml" @change="handleUploadXML()">
        </div>

        <!-- FORMULARIO DE EDICAO DA DI -->
        <nfimport-form v-if="showForm" :params="params" :crud="crud" v-on:closeform="closeForm"></nfimport-form>

        <!-- FORMULARIO DE EDICAO DA NF -->
        <nfsaida-form v-if="showEntradaForm" :params="params" :crud="crud" v-on:closeform="closeForm"></nfsaida-form>
    </div>
</template>


<style scoped>
.mainbox {
  min-height:100px;
}
</style>



// WEBPACK FOOTER //
// src/forms/nfimport-list.vue